var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showMenu)?_c('navMenu'):_vm._e(),_c('div',{staticClass:"appContent"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }